<template>
  <div class="container page main">
    <div class="nav">
      <img src="/img/mine/recharge_arrow_left.png"  @click="back()"/>
      <div class="title">{{ $t('withdraw.bind_account_title') }}</div>
      <div>&nbsp;&nbsp;&nbsp;</div>
    </div>
    <div class="card">
      <div class="header">
        <van-image round class="user_img" src="/img/nan/11.png">
          <template v-slot:loading>
            <van-loading type="spinner"/>
          </template>
        </van-image>
      </div>
      <div class="info">
        <div class="name">{{ userInfo.username }}</div>
        <div class="code">Credit Score: {{ userInfo.amount_code }}</div>
      </div>
    </div>

     
    <div class="ipu">
      <template v-if="accountRows.length">
        <div class="row" v-for="row in accountRows" :key="row.key">
          <div class="title">{{ row.title }}</div>
          <div class="value">{{ row.value }}</div>
        </div>
      </template>
      <div v-else class="empty">
        <div class="empty-text">{{ $t("withdraw.account_empty") }}</div>
        <div class="empty-btn" @click="goBind">{{ $t("withdraw.go_bind") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { describeWithdrawInfo, parseWithdrawInfo, resolveWithdrawConfig, resolveWithdrawFields } from '@/common/withdrawForm';

export default {
  data() {
    return {
      withdrawFields: [],
      accountInfo: {},
      userInfo:{}
    };
  },
  computed: {
    accountRows() {
      return describeWithdrawInfo(this.withdrawFields, this.accountInfo);
    }
  },
  methods: {
    back(){
      return window.history.back();
    },
    goBind(){
      this.$router.push('/BindCard');
    },
    getWithdrawConfig(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_config'
      }).then(res=>{
        if(res && res.code === 200){
          const config = resolveWithdrawConfig(res);
          this.withdrawFields = resolveWithdrawFields(config);
          this.accountInfo = parseWithdrawInfo(config.account && config.account.withdraw_info);
        }else if(res && res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getWithdrawConfig();
    }
  }
};
</script>

<style lang='less' scoped>
.nav{
  width: 95%;
  margin: 5% auto 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img{
    width: 2.5rem;
    height: 2.8125rem;
  }
  .title{
    color: #c45b86;
    font-size: 1.4rem;
  }
}
.card{
  background-image: url("/public/img/mine/bank_card.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // width: 100%;
  height: 10vh;
  margin: 5% 2.5%;
  display: flex;
  align-items: center;
  padding: 2% 5%;
  .info{
    color: #fff;
    margin-left: 1rem;
  }
}


.user_img {
  height: 3.75rem;
  width: 3.75rem;
  border: 1px solid #ff1a6d;
}



.ipu{
  width: 95%;
  margin: 0 auto 0;
  background: linear-gradient(90deg, #332348, #261d3e, #324);
  border-radius: 0.5rem;
  border: 0.125rem solid #5e3876;
  padding: 4%;
  .title{
    font-size: 1rem;
    color: #fff;
  }
  .value{
    font-size: 1rem;
    color: #fff;
    margin-top: 0.6rem;
    word-break: break-all;
  }

  .row{
    // border-bottom: 0.125rem solid #5e3876;
    padding: 1rem 0;
  }
  .row + .row{
    border-top: 0.125rem solid #5e3876;
  }

  .empty{
    padding: 1.5rem 0;
    text-align: center;
    .empty-text{
      color: #fff;
      font-size: 0.94rem;
    }
    .empty-btn{
      width: 8rem;
      margin: 1rem auto 0;
      padding: 0.6rem 0;
      border-radius: 0.9rem;
      color: #fff;
      font-size: 0.88rem;
      background: linear-gradient(120deg, #f7a1c0 0%, #c3a3f2 55%, #ffbe9c 100%);
    }
  }
}


</style>
